export const assetCreditLabels = {
    en: {
        exportCsv: 'Export assets as CSV',
        draftWithdrawal: 'Withdraw proposal',
        withdrawn: 'Withdrawn proposal',
        title: 'Asset purchase credit',
        originalCost: 'Original acquisition cost',
        currentCost: 'Adjusted acquisition cost',
        sourcePosition: 'Original cost line',
        creditPosition: 'Credit cost line',
        sourceAllocation: 'Original cost assigned to this asset',
        reduction: 'Acquisition cost reduction',
        unregistered: 'Unregistered cost share',
        asOf: 'As of',
        history: 'Acquisition cost adjustments',
        explanation: 'Assign the original cost and this credit to the affected assets. The supplier credit posts the cost reduction once; refunds do not reduce it again. Commercial depreciation keeps the original useful-life end and already posted amounts.',
        dependencies: 'Open the asset to reverse dependent depreciation or disposal first. Reopen a locked period through year closing if required; then review and post replacement depreciation. Original journals remain available.',
        errors: {
            proof: 'Review the original cost lines and exact asset shares again.',
            capacity: 'The credit exceeds the remaining cost assigned to this asset or source line.',
            dependencies: 'Reverse dependent depreciation or disposal in the asset register before posting this cost adjustment.',
        },
    },
    de: {
        exportCsv: 'Anlagen als CSV exportieren',
        draftWithdrawal: 'Vorschlag zurückziehen',
        withdrawn: 'Zurückgezogener Vorschlag',
        title: 'Anlagenbezogene Lieferantengutschrift',
        originalCost: 'Ursprüngliche Anschaffungskosten',
        currentCost: 'Berichtigte Anschaffungskosten',
        sourcePosition: 'Ursprüngliche Kostenposition',
        creditPosition: 'Kostenposition der Gutschrift',
        sourceAllocation: 'Der Anlage zugeordnete ursprüngliche Kosten',
        reduction: 'Minderung der Anschaffungskosten',
        unregistered: 'Nicht im Anlagenregister zugeordneter Anteil',
        asOf: 'Stichtag',
        history: 'Änderungen der Anschaffungskosten',
        explanation: 'Ordnen Sie die ursprünglichen Kosten und diese Gutschrift den betroffenen Anlagen zu. Die Gutschrift bucht die Kostenminderung einmal; Erstattungen mindern sie nicht erneut. Die handelsrechtliche Abschreibung behält das bisherige Nutzungsdauerende und bereits gebuchte Beträge.',
        dependencies: 'Öffnen Sie die Anlage und buchen Sie zuerst abhängige Abschreibungen oder Abgänge zurück. Öffnen Sie nötigenfalls die gesperrte Periode über den Jahresabschluss; prüfen und buchen Sie anschließend Ersatzabschreibungen. Ursprüngliche Buchungen bleiben erhalten.',
        errors: {
            proof: 'Prüfen Sie die ursprünglichen Kostenpositionen und die genauen Anlagenanteile erneut.',
            capacity: 'Die Gutschrift überschreitet die verbleibenden Kosten der Anlage oder Quellposition.',
            dependencies: 'Buchen Sie abhängige Abschreibungen oder Abgänge zuerst im Anlagenregister zurück.',
        },
    },
    es: {
        exportCsv: 'Exportar activos como CSV',
        draftWithdrawal: 'Retirar propuesta',
        withdrawn: 'Propuesta retirada',
        title: 'Abono de adquisición de activos',
        originalCost: 'Coste de adquisición original',
        currentCost: 'Coste de adquisición ajustado',
        sourcePosition: 'Línea de coste original',
        creditPosition: 'Línea de coste del abono',
        sourceAllocation: 'Coste original asignado al activo',
        reduction: 'Reducción del coste de adquisición',
        unregistered: 'Parte no asignada al registro',
        asOf: 'Fecha de consulta',
        history: 'Ajustes del coste de adquisición',
        explanation: 'Asigne el coste original y este abono a los activos afectados. El abono contabiliza la reducción una sola vez; el reembolso no la repite. La amortización mercantil conserva el fin de la vida útil y los importes ya contabilizados.',
        dependencies: 'Abra el activo y revierta primero las amortizaciones o bajas dependientes. Si procede, reabra el período bloqueado mediante el cierre anual; después revise y contabilice las amortizaciones sustitutivas. Se conservan los asientos originales.',
        errors: {
            proof: 'Revise las líneas originales y las partes exactas de cada activo.',
            capacity: 'El abono supera el coste restante asignado al activo o línea original.',
            dependencies: 'Revierta primero las amortizaciones o bajas dependientes en el registro de activos.',
        },
    },
    fr: {
        exportCsv: 'Exporter les immobilisations en CSV',
        draftWithdrawal: 'Retirer la proposition',
        withdrawn: 'Proposition retirée',
        title: 'Avoir sur acquisition d’immobilisation',
        originalCost: 'Coût d’acquisition initial',
        currentCost: 'Coût d’acquisition ajusté',
        sourcePosition: 'Ligne de coût initiale',
        creditPosition: 'Ligne de coût de l’avoir',
        sourceAllocation: 'Coût initial affecté à l’immobilisation',
        reduction: 'Réduction du coût d’acquisition',
        unregistered: 'Part non affectée au registre',
        asOf: 'Situation au',
        history: 'Ajustements du coût d’acquisition',
        explanation: 'Affectez le coût initial et cet avoir aux immobilisations concernées. L’avoir comptabilise une seule réduction ; le remboursement ne la répète pas. L’amortissement comptable conserve la fin de durée d’utilisation et les montants déjà comptabilisés.',
        dependencies: 'Ouvrez l’immobilisation et extournez d’abord les amortissements ou sorties dépendants. Si nécessaire, rouvrez la période bloquée via la clôture annuelle, puis contrôlez et comptabilisez les amortissements de remplacement. Les écritures initiales sont conservées.',
        errors: {
            proof: 'Vérifiez les lignes initiales et les parts exactes des immobilisations.',
            capacity: 'L’avoir dépasse le coût restant affecté à l’immobilisation ou à la ligne source.',
            dependencies: 'Extournez d’abord les amortissements ou sorties dépendants dans le registre.',
        },
    },
    tr: {
        exportCsv: 'Varlıkları CSV olarak dışa aktar',
        draftWithdrawal: 'Öneriyi geri çek',
        withdrawn: 'Geri çekilen öneri',
        title: 'Varlık alımına ilişkin tedarikçi alacak notu',
        originalCost: 'İlk edinim maliyeti',
        currentCost: 'Düzeltilmiş edinim maliyeti',
        sourcePosition: 'İlk maliyet satırı',
        creditPosition: 'Alacak notu maliyet satırı',
        sourceAllocation: 'Varlığa atanan ilk maliyet',
        reduction: 'Edinim maliyeti indirimi',
        unregistered: 'Sicile atanmamış maliyet payı',
        asOf: 'İtibarıyla',
        history: 'Edinim maliyeti düzeltmeleri',
        explanation: 'İlk maliyeti ve bu alacak notunu ilgili varlıklara atayın. Alacak notu maliyet indirimini bir kez kaydeder; geri ödeme tekrarlamaz. Ticari amortisman kullanım süresinin sonunu ve kaydedilmiş tutarları korur.',
        dependencies: 'Varlığı açıp önce bağımlı amortisman veya elden çıkarma kayıtlarını ters kaydedin. Gerekirse yıl kapanışından kilitli dönemi yeniden açın; ardından yeni amortismanları inceleyip kaydedin. İlk kayıtlar korunur.',
        errors: {
            proof: 'İlk maliyet satırlarını ve varlık paylarını yeniden inceleyin.',
            capacity: 'Alacak notu varlığa veya kaynak satıra atanan kalan maliyeti aşıyor.',
            dependencies: 'Önce varlık sicilinde bağımlı amortisman veya elden çıkarma kayıtlarını ters kaydedin.',
        },
    },
};
//# sourceMappingURL=asset-credit-labels.js.map